/** Common Lambda statuses. */
export enum CommonLambdaStatus {
  /** The data silo credentials have expired. */
  SiloCredentialsExpired = 'SILO_CREDENTIALS_EXPIRED',
  /** The data silo needs to be updated due to new permissions, etc. */
  SiloPermissionsUpdated = 'SILO_CREDENTIALS_UPDATED',
}

/**
 * The placeholders for the disco class scan error messages
 */
export enum DiscoClassScanErrorPlaceholder {
  /** Generic retryable error */
  RetryableError = '{RetryableError}',
  /** Any permission error */
  PermissionError = '{PermissionError}',
  /** too many requests error */
  TooManyRequestsError = '{TooManyRequestsError}',
  /** No content found error */
  NoContentFoundError = '{NoContentFoundError}',
  /** Invalid argument error */
  InvalidArgumentError = '{InvalidArgumentError}',
  /** Transcend error */
  TranscendError = '{TranscendError}',
}
